import { CampaignFloatingToolBarPostsController } from './campaign-floating-tool-bar-posts.controller'

function campaignFloatingToolBarPosts () {
  return {
    restrict: 'E',
    scope: {
      selectedPost: '=',
      action: '=',
      campaign: '='
    },
    templateUrl: '/campaigns/directives/campaign-floating-tool-bar-posts/campaign-floating-tool-bar-posts.html?$$REVISION$$',
    controller: CampaignFloatingToolBarPostsController
  }
}

export { campaignFloatingToolBarPosts }
